import { createContext as t, useContext as r } from "react";
const o = t({}), p = o.Provider, n = () => r(o);
export {
  p as TypographyProvider,
  n as useTypography
};
